import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'kt-lock-dialog',
  templateUrl: './lock-dialog.component.html',
  styleUrls: ['./lock-dialog.component.scss']
})
export class LockDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<LockDialogComponent>
    ) {}

  ngOnInit() {    
  }

}
